export default {"src":"/_next/static/media/ico_pen_write.5f568f16.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};